/**
 * Shared react-select styling matching the Rotary design reference's
 * ".custom-dropdown-trigger" glass look — 42px height, translucent white,
 * red glow on focus. Used across every list page's filter dropdowns.
 */
export const glassSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    height: 42,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    borderRadius: 12,
    border: state.isFocused ? "1px solid #0033A0" : "1px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(0, 51, 160, 0.12)" : "none",
    fontSize: "0.88rem",
    color: "#334155",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": { borderColor: state.isFocused ? "#0033A0" : "#cbd5e1" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 14px", height: 40 }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  placeholder: (base) => ({ ...base, color: "#94a3b8", fontSize: "0.88rem" }),
  singleValue: (base) => ({ ...base, color: "#334155" }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, color: "#94a3b8", padding: "0 10px" }),
  clearIndicator: (base) => ({ ...base, color: "#94a3b8", padding: "0 4px" }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({ ...base, borderRadius: 12, overflow: "hidden", zIndex: 9999 }),
};

/**
 * Rotary form.html member select — solid white, 10px curve (Create/Edit Member).
 */
export const memberFormSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    height: 42,
    backgroundColor: "#ffffff",
    borderRadius: 10,
    border: state.isFocused ? "1px solid #0033A0" : "1px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(0, 51, 160, 0.1)" : "none",
    fontSize: "0.88rem",
    fontFamily: "Inter, sans-serif",
    color: "#334155",
    cursor: "pointer",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    "&:hover": { borderColor: state.isFocused ? "#0033A0" : "#cbd5e1" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 14px", height: 40 }),
  input: (base) => ({ ...base, margin: 0, padding: 0, fontFamily: "Inter, sans-serif" }),
  placeholder: (base) => ({
    ...base,
    color: "#94a3b8",
    fontSize: "0.88rem",
    fontFamily: "Inter, sans-serif",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#334155",
    fontFamily: "Inter, sans-serif",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#64748b",
    padding: "0 10px",
  }),
  clearIndicator: (base) => ({ ...base, color: "#94a3b8", padding: "0 4px" }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({
    ...base,
    borderRadius: 10,
    overflow: "hidden",
    zIndex: 9999,
  }),
};

